<template>
    <c-badge
        :class="background"
        class="badge-lg d-flex align-items-center gap-1"
    >
        <em :class="operability" class="operability-indicator" />
        <span :class="color" class="badge-label">
            {{ trans('general.assetstatus.' + operability) }}
        </span>
    </c-badge>
</template>
<script>
import { CBadge } from '@coreui/vue-pro/dist/esm/components/badge/index.js';

export default {
    components: { CBadge },
    props: {
        usage: {},
        operability: {},
        inline: { type: Boolean, default: false },
    },
    computed: {
        label() {
            let key = this.usage ?? 'onboarded';
            return this.trans('assets.status.' + key);
        },
        color() {
            return this.operability === 'operable'
                ? 'text-success'
                : 'text-danger';
        },
        background() {
            if (this.inline) {
                return 'bg-transparent px-0 badge-inline';
            }

            if (this.operability === 'inoperable') {
                return 'badge-inoperable';
            }

            if (this.operability === 'operable') {
                return 'badge-operable';
            }

            return 'bg-secondary';
        },
    },
};
</script>
<style scoped>
.badge-inline .badge-label {
    font-weight: normal;
    text-transform: capitalize;
}

.operability-indicator {
    width: 7px;
    height: 7px;
    display: inline-block;
    border-radius: 100%;
}
</style>
